import { getMomentTz } from "@dexteel/mesf-core";
import { Grid, Paper } from "@mui/material";
import {
  ArrowBackRounded,
  ArrowForwardRounded,
  SkipNext,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import { Moment } from "moment";
import React from "react";

interface DatePickerControlProps {
  value: Date;
  onChange: (date: Date) => void;
  label?: string;
}

const moment = getMomentTz();

export const DatePickerControl: React.FC<DatePickerControlProps> = ({
  value,
  onChange,
  label = "Current Date",
}) => {
  const handleDateChange = (date: Moment | null) => {
    if (!date) return null;
    const newDate = date.toDate();
    onChange(newDate);
  };

  const isCurrentDate = moment(value).isSame(moment(), "day");

  return (
    <Paper style={{ padding: "8px 0px" }}>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item>
          <ArrowBackRounded
            color="primary"
            style={{ cursor: "pointer" }}
            onClick={() => onChange(moment(value).subtract(1, "days").toDate())}
          />
        </Grid>
        <Grid item md={7}>
          <DatePicker
            label={label}
            value={moment(value)}
            onChange={handleDateChange}
            format="MM/DD/YYYY"
            slotProps={{
              textField: { size: "small" },
            }}
          />
        </Grid>
        <Grid item>
          <ArrowForwardRounded
            color={isCurrentDate ? "disabled" : "primary"}
            style={{ cursor: isCurrentDate ? "default" : "pointer" }}
            onClick={() => {
              if (!isCurrentDate) {
                onChange(moment(value).add(1, "days").toDate());
              }
            }}
          />
        </Grid>
        <Grid item>
          <SkipNext
            color={isCurrentDate ? "disabled" : "primary"}
            style={{ cursor: isCurrentDate ? "default" : "pointer" }}
            onClick={() => {
              if (!isCurrentDate) {
                onChange(moment().toDate());
              }
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
